import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'group inline-flex items-center justify-center gap-2 text-sm leading-5 font-medium whitespace-nowrap transition-colors focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-foreground hover:bg-primary/70 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 [&_svg]:size-4',
        destructive:
          'bg-secondary text-destructive hover:bg-secondary/80 focus-visible:border-ring focus-visible:bg-secondary/60 focus-visible:ring-[3px] focus-visible:ring-destructive/20 [&_svg]:size-4',
        outline:
          'border border-input bg-background text-foreground shadow-xs hover:bg-accent focus-visible:border-ring focus-visible:bg-background focus-visible:ring-[3px] focus-visible:ring-ring/50 [&_svg]:size-4',
        secondary:
          'border border-transparent bg-secondary hover:bg-secondary/80 focus-visible:bg-secondary focus-visible:ring-[3px] focus-visible:ring-ring/50 [&_svg]:size-4',
        ghost:
          'hover:bg-accent hover:text-accent-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
        link: 'text-link underline-offset-4 hover:underline focus-visible:border-ring focus-visible:underline focus-visible:ring-[3px] focus-visible:ring-ring/50 [&_svg]:size-4',
      },
      rounded: {
        true: 'rounded-3xl',
        false: 'rounded-none',
      },
      size: {
        sm: 'h-8 px-3 text-sm',
        default: 'h-9 px-4 text-sm',
        lg: 'h-10 px-6 text-base',
        icon: 'h-9 w-9',
        iconSm: 'h-8 w-8',
        iconLg: 'h-10 w-10',
        none: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      rounded: true,
      size: 'default',
    },
  },
);
